// Vite-injected runtime configuration. Values are baked in at build time by
// scripts/deploy-frontend.sh based on Terraform outputs.

function required(value: string | undefined, name: string): string {
  if (!value || value.length === 0) {
    throw new Error(`missing build-time env: ${name}`);
  }
  return value;
}

function optional(value: string | undefined): string {
  return value ?? "";
}

export type AuthMode = "backend" | "direct";

export const config = {
  appOrigin: required(import.meta.env.VITE_APP_ORIGIN, "VITE_APP_ORIGIN"),
  /** Apex landing origin (https://couplesgames.click) — target for Home/Profile/Stats menu links. */
  landingOrigin: required(import.meta.env.VITE_LANDING_ORIGIN, "VITE_LANDING_ORIGIN"),
  cognitoHostedUi: required(
    import.meta.env.VITE_COGNITO_HOSTED_UI,
    "VITE_COGNITO_HOSTED_UI",
  ),
  cognitoClientId: required(
    import.meta.env.VITE_COGNITO_CLIENT_ID,
    "VITE_COGNITO_CLIENT_ID",
  ),
  /** WebSocket endpoint (games only; empty for the landing page). */
  wsEndpoint: optional(import.meta.env.VITE_WS_ENDPOINT),
  /** Base URL of the shared stats read API. */
  statsApi: required(import.meta.env.VITE_STATS_API, "VITE_STATS_API"),
  /**
   * "backend" — tokens are issued via the game's own API (/api/auth/*) with an
   * httpOnly refresh cookie (the default, used by every game).
   * "direct" — the SPA exchanges the auth code against Cognito directly and
   * keeps the token in sessionStorage (no refresh cookie). Used by the landing.
   */
  authMode: (import.meta.env.VITE_AUTH_MODE ?? "backend") as AuthMode,
} as const;

export const authCallbackPath = "/auth/callback";

export function callbackUri(): string {
  return `${config.appOrigin}${authCallbackPath}`;
}
